<template>
  <div>
    <transition name="slide-fade-up">
      <b-img
        :src="require('@/assets/images/logo_centered.svg')"
        width="300"
        class="rounded-0"
        v-show="show"
      />
    </transition>

    <div class="mt-5">
      <h4 class="font-weight-bold">Log in to Schedulized</h4>
      <!-- <p class="mt-1">
        Lorem ipsum dolor sit amet, consetetur sadipscing elitr
      </p> -->
    </div>

    <b-form class="mt-4" @submit.prevent="onSubmit">
      <b-form-group id="input-group-1" class="col-12">
        <i class="clearable" v-show="form.username" @click="form.username = ''"
          >&times;</i
        >
        <b-form-input
          id="input-1"
          v-model="form.username"
          class="input-effect"
          :class="form.username ? 'has-content' : ''"
          type="email"
          required
          autofocus
        ></b-form-input>
        <label>Email address</label>
        <div class="input-error" v-if="form.$getError('username')">
          {{ form.$getError('username')[0] }}
        </div>
      </b-form-group>

      <b-form-group id="input-group-2" class="col-12">
        <i class="clearable encryptable" v-show="form.password">
          <b-icon
            scale="0.5"
            icon="eye-slash-fill"
            v-if="showPassword"
            @click="showPassword = false"
          ></b-icon>
          <b-icon
            scale="0.5"
            icon="eye-fill"
            v-else
            @click="showPassword = true"
          ></b-icon>
        </i>
        <b-form-input
          id="input-2"
          v-model="form.password"
          class="input-effect"
          :class="form.password ? 'has-content' : ''"
          :type="showPassword ? 'text' : 'password'"
          autocomplete="new-password"
          required
        ></b-form-input>
        <label>Password</label>
      </b-form-group>

      <div class="mb-4 input-error" v-show="form.$errorMessage">
        {{ form.$errorMessage }}
      </div>

      <div class="form-link-cont mb-4">
        <b-link class="form-link" to="/forgot-password"
          >Forgot password?</b-link
        >
      </div>

      <b-button type="submit" variant="primary" block>
        <b-spinner class="mr-2" small v-if="form.$busy" />Log in
      </b-button>

      <div class="mt-4">
        Don’t have an account?
        <b-link class="form-link" :to="{ name: 'auth.register-page' }"
          >Create one</b-link
        >
      </div>

      <div class="mt-4">
        By logging in, you accept to Schedulized’s
        <br />
        <b-link
          class="form-link"
          target="_blank"
          :to="{ name: 'terms-of-service' }"
          >Terms and Conditions</b-link
        >&nbsp;&
        <b-link
          class="form-link"
          target="_blank"
          :to="{ name: 'privacy-policy' }"
          >Privacy Policy</b-link
        >.
      </div>
      <div class="mt-5">
        Got questions? See
        <b-link
          class="form-link"
          target="_blank"
          :to="{ name: 'frequently-asked-questions' }"
          >FAQs</b-link
        >
      </div>
    </b-form>
  </div>
</template>

<script>
import Form from '@/utils/form'
import Cookie from 'js-cookie'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      show: false,
      showPassword: false,
      form: new Form({
        username: '', // this accepts email or phone number in API; for web app, email should suffice
        password: ''
      })
    }
  },
  computed: {
    ...mapState({
      board: state => state.board.boardDetails
    })
  },

  methods: {
    ...mapActions({
      getBoardDetails: 'board/getBoardDetails',
      scanBoard: 'board/scanBoard'
    }),
    async onSubmit(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/login', this.form.$data())
        .then(async ({ data }) => {
          this.form.$busy = false
          await this.$store.commit('auth/setToken', data.data)
          await this.$store.commit('auth/setUser', data.data.user)
          const boardId = Cookie.get('qr_board_id')
          Cookie.remove('qr_board_id')
          if (boardId) {
            this.scanBoard({ board_id: boardId })
              .then(() => {
                this.getBoardDetails(boardId).then(() => {
                  this.$router.replace({
                    name: 'board.board-details-page',
                    params: {
                      name: this.board.site.name,
                      id: boardId
                    }
                  })
                })
              })
              .catch(_ => {
                this.loading = false
                Cookie.remove('qr_board_id')
                this.$router.push({ name: 'auth.login-page' })
              })
              .catch(() => {
                this.$router.replace({ name: 'job.feed-page' })
                Cookie.remove('qr_board_id')
              })
            return
          }

          this.$router.replace({ name: 'job.feed-page' })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  mounted() {
    this.show = true
  },

  watch: {
    '$route.query.email': {
      handler(value) {
        this.form.username = value
      },
      immediate: true
    },
    'form.username'() {
      this.form.$clearError('username')
    },

    'form.password'() {
      this.form.$clearError('password')
    }
  }
}
</script>

<style lang="scss" scoped>
.form-link {
  font-weight: bold;
}
.encryptable {
  right: 8px;
}
</style>
